import { PROVIDER_OPTIONS } from 'components/shared/Filters/lib/filterOptions';

export const DEFAULT_FILTERS = {
  // date: {
  //   type: 'date-range',
  //   title: 'Date of Medication',
  //   icon: 'calendar-mono'
  // },
  prescriber: {
    queryKey: 'prescribers.options',
    title: 'Prescriber',
    placeholder: 'Search provider',
    icon: 'user-square-mono',
    allowed_operators: ['is', 'is not']
  },
  created_by: {
    ...PROVIDER_OPTIONS,
    allowed_operators: ['is', 'is not']
  }
};
